import {
  type RenaissanceSchoolClientT,
  type WeakRenaissanceSchoolClientT
} from '@frontrow/console/src/models/school'

export type ValidationResultT =
  | {
      tag: 'valid'
      result: RenaissanceSchoolClientT
    }
  | {
      tag: 'invalid'
    }
  | {
      tag: 'nonexistent'
    }

export function validateRenaissanceSchoolClient(
  client: WeakRenaissanceSchoolClientT
): ValidationResultT {
  const {platform, clientId, rpid, baseUrl, starStatus, sharedRosteringEnabled} = client

  if (
    isNullOrUndefinedOrEmptyString(clientId) ||
    isNullOrUndefinedOrEmptyString(rpid) ||
    isNullOrUndefinedOrEmptyString(baseUrl)
  ) {
    return {tag: 'nonexistent'}
  }

  if (sharedRosteringEnabled && platform !== 'renaissance_growth_platform') {
    return {tag: 'invalid'}
  }

  if (
    !isNullOrUndefinedOrEmptyString(platform) &&
    !isNullOrUndefinedOrEmptyString(clientId) &&
    !isNullOrUndefinedOrEmptyString(rpid) &&
    !isNullOrUndefinedOrEmptyString(baseUrl)
  ) {
    try {
      const url = formattedUrl(baseUrl as string)
      return {
        tag: 'valid',
        result: {
          platform: platform as string,
          clientId: clientId as string,
          rpid: rpid as string,
          baseUrl: url,
          starStatus,
          sharedRosteringEnabled
        }
      }
    } catch {
      return {tag: 'invalid'}
    }
  }

  return {tag: 'invalid'}
}

function formattedUrl(baseUrl: string): string {
  const url = new URL(baseUrl)
  if (url.protocol !== 'https:') {
    throw new Error('Invalid protocol: we only accept https')
  }
  const croppedUrl = url.origin.toString()
  return croppedUrl
}

function isNullOrUndefinedOrEmptyString(x?: string | null): boolean {
  return x === null || x === undefined || x.trim().length === 0
}

export function renaissanceFieldsRequired(
  isRenaissanceActiveIdp: boolean,
  client: WeakRenaissanceSchoolClientT
): boolean {
  const {clientId, rpid, baseUrl, starStatus} = client

  const anyBaseFieldPresent =
    !isNullOrUndefinedOrEmptyString(clientId) ||
    !isNullOrUndefinedOrEmptyString(rpid) ||
    !isNullOrUndefinedOrEmptyString(baseUrl)

  return anyBaseFieldPresent || starStatus === 'star_enabled' || isRenaissanceActiveIdp
}
